const contactItems = [
  {
    icon: "ri-map-pin-line",
    label: "Address",
    lines: ["MILENTIJA POPOVICA 43", "City: Beograd", "Zip: 190760"],
  },
  {
    icon: "ri-global-line",
    label: "Country",
    lines: ["Serbia"],
  },
  {
    icon: "ri-mail-line",
    label: "Email",
    lines: ["help@medestdoo.com"],
  },
  {
    icon: "ri-phone-line",
    label: "Number",
    lines: ["+1 6812339611"],
  },
];

export default function ContactSection() {
  return (
    <section id="contact" className="w-full bg-white py-24 md:py-32">
      <div className="w-full px-6 md:px-20">

        {/* Header */}
        <div className="mb-16">
          <span className="text-xs font-semibold tracking-[0.3em] uppercase text-gray-400 bg-gray-100 rounded-full px-4 py-1.5">
            Get In Touch
          </span>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-black text-gray-900 leading-none tracking-tight mt-6">
            <span className="block">Contact Us.</span>
          </h2>
          <p className="text-gray-400 font-light text-sm md:text-base leading-relaxed mt-4 max-w-md">
            Have questions about our products or need support? Our team is always
            ready to assist you.
          </p>
        </div>

        {/* Contact grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 border-t border-gray-100 pt-12">
          {contactItems.map((item) => (
            <div key={item.label}>
              <div className="flex items-center gap-3 mb-4">
                <div className="w-8 h-8 flex items-center justify-center rounded-full bg-gray-50">
                  <i className={`${item.icon} text-gray-600 text-sm`}></i>
                </div>
                <p className="text-xs font-bold tracking-[0.25em] uppercase text-gray-900">{item.label}</p>
              </div>
              <div className="w-full h-px bg-gray-100 mb-4"></div>
              {item.lines.map((line) => (
                <p key={line} className="text-gray-500 text-sm font-light leading-relaxed">
                  {line}
                </p>
              ))}
            </div>
          ))}
        </div>

        {/* Bottom map-inspired visual */}
        <div
          className="mt-16 rounded-3xl overflow-hidden"
          style={{ background: "linear-gradient(135deg, #0a2e2a 0%, #0d3d34 60%, #0f4a3f 100%)" }}
        >
          <div className="flex flex-col lg:flex-row items-stretch">
            {/* Left text block */}
            <div className="flex-1 p-10 md:p-14 flex flex-col justify-center">
              <p className="text-white/50 text-xs tracking-widest uppercase mb-3">Location</p>
              <h3 className="text-2xl md:text-3xl font-black text-white leading-tight">
                Based in Belgrade,<br />Serbia.
              </h3>
              <p className="text-white/60 text-sm font-light mt-5 leading-relaxed max-w-sm">
                Our headquarters are located in the heart of Belgrade, Serbia — a growing hub for
                technology innovation and software talent in Southeast Europe.
              </p>
              <div className="mt-8 flex flex-col gap-3">
                <div className="flex items-start gap-3">
                  <i className="ri-map-pin-line text-white/40 mt-0.5 shrink-0"></i>
                  <span className="text-white/70 text-sm">MILENTIJA POPOVICA 43, Beograd 190760, Serbia</span>
                </div>
                <div className="flex items-center gap-3">
                  <i className="ri-mail-line text-white/40 shrink-0"></i>
                  <span className="text-white/70 text-sm">help@medestdoo.com</span>
                </div>
                <div className="flex items-center gap-3">
                  <i className="ri-phone-line text-white/40 shrink-0"></i>
                  <span className="text-white/70 text-sm">+1 6812339611</span>
                </div>
              </div>
            </div>
            {/* Right image */}
            <div className="lg:w-[420px] xl:w-[480px] shrink-0 h-[280px] lg:h-auto overflow-hidden">
              <img
                src="https://public.readdy.ai/ai/img_res/b37e073faf43bcceda9951e6bb2e0997.jpg"
                alt="Belgrade, Serbia"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>

      </div>

      {/* Footer bar */}
      <div className="w-full px-6 md:px-20 mt-20 pt-8 border-t border-gray-100">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <div>
            <p className="text-2xl md:text-3xl font-black text-gray-900 tracking-tight">MEDEST D.O.O.</p>
            <p className="text-gray-400 text-xs mt-1 tracking-wider">iOS Platform Specialists &middot; Belgrade, Serbia</p>
          </div>
          <div className="text-right">
            <p className="text-gray-400 text-xs">&copy; {new Date().getFullYear()} MEDEST D.O.O. All rights reserved.</p>
            <p className="text-gray-300 text-xs mt-0.5">Registered company in Serbia.</p>
          </div>
        </div>
      </div>
    </section>
  );
}
